import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { shallow } from 'zustand/shallow';
import { useStore } from './store/hooks.js';
import { Status } from '#~/device/components/status/index.js';
import { Container } from '#~/video/components/viewer/index.js';

/** `<Preview>` component. */
export const Preview = (props: HtmlAttributes): ReactElement => {
  const [candidate, status] = useStore((µ) => [µ.candidate, µ.external.status], shallow);

  return (
    <Container deviceId={candidate.id} {...props}>
      <Status deviceId={candidate.id} status={status} />
    </Container>
  );
};
